export default (trackingNumber) => {
    const vTrackingNumber = (trackingNumber.replace('%', '') + '').trim()

    console.log(vTrackingNumber)

    const detectors = [
        /^([0-9]+)?$/gi,
        /[A-Z]{2}\d+[A-Z]{2}$/gi,
        /[A-Z]{4}[0-9]{10}/gi, // New Royal Mail (PARCEL FORCE) format (e.g: PBJD5471899001)
        /[A-Z0-9]{7}\d+/gi // New format Multrans EU Original Carrier DPDUK(e.g: NR289LB15503758521204812826)
    ]

    for (const regex of detectors) {
        if (regex.test(vTrackingNumber)) return true
    }

    return false
}

